import React from 'react';

const Referral = (props) => {
  return (
    <div className="bg-background p-4 w-screen h-screen">Referral Screen</div>
  );
};

export default Referral;
